/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringResource
 */
export interface StringResource {
    /**
     * 
     * @type {string}
     * @memberof StringResource
     */
    value?: string;
}

/**
 * Check if a given object implements the StringResource interface.
 */
export function instanceOfStringResource(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StringResourceFromJSON(json: any): StringResource {
    return StringResourceFromJSONTyped(json, false);
}

export function StringResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringResource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function StringResourceToJSON(value?: StringResource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

